(function() {
  const initCalculator = () => {
    // Selections Variant ID injected globally by surcharge-config.liquid via Liquid
    // window.__SELECTIONS_VARIANT_ID__ is available at page load time

    // --- 1. Tab Switcher Logic (Independent of Calculator) ---
    const tabNav = document.getElementById('product-tabs-nav');
    const tabContent = document.getElementById('product-tabs-content');
    
    if (tabNav && tabContent) {
    const tabBtns = tabNav.querySelectorAll('.tab-btn');
    const tabPanes = tabContent.querySelectorAll('.tab-pane');
    
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetTab = btn.dataset.tab;
        
        // Update Buttons
        tabBtns.forEach(b => {
          if (b === btn) {
            b.classList.remove('border-transparent', 'text-gray-500');
            b.classList.add('border-[#2D4B3E]', 'text-black');
          } else {
            b.classList.add('border-transparent', 'text-gray-500');
            b.classList.remove('border-[#2D4B3E]', 'text-black');
          }
        });
        
        // Update Panes with fade effect
        tabPanes.forEach(pane => {
          if (pane.id === `tab-content-${targetTab}`) {
            pane.classList.remove('hidden');
            // Small delay to allow display:block to apply before opacity transition
            setTimeout(() => {
              pane.classList.remove('opacity-0');
              pane.classList.add('opacity-100');
            }, 20);
          } else {
            pane.classList.remove('opacity-100');
            pane.classList.add('opacity-0');
            pane.classList.add('hidden');
          }
        });
      });
    });
  }

  // --- 2. Calculator Logic ---
  // Skip calculator initialization if no #curtain-calculator-app element
  // Question mark drawer and swatch drawer should still work
  const app = document.getElementById('curtain-calculator-app');
  if (app) {

  const variantId = app.dataset.variantId;
  
  // Initialize State
  // Set default color to the first available one in the DOM if possible
  const activeColorBtn = document.querySelector('.color-option.border-2');
  const defaultColor = activeColorBtn ? activeColorBtn.dataset.value : (document.querySelector('.color-option') ? document.querySelector('.color-option').dataset.value : '');
  
  const state = {
    variantId: variantId,
    color: defaultColor,
    header: '',
    width: '',
    length: '',
    lining: '',
    liningSurcharge: 0,
    trim: '',
    trimPrice: 0,
    tieback: '',
    tiebackPrice: 0,
    memory: '',
    quantity: 1,
    basePrice: parseFloat(app.dataset.basePrice || 0),
    wRate1: parseFloat(app.dataset.wRate1 || 0),
    wRate2: parseFloat(app.dataset.wRate2 || 0),
    wRate3: parseFloat(app.dataset.wRate3 || 0),
    lRate1: parseFloat(app.dataset.lRate1 || 0),
    lRate2: parseFloat(app.dataset.lRate2 || 0),
    widthMultiplier: 0,
    lengthMultiplier: 0,
    minWidth: parseInt(app.dataset.minWidth || 14, 10),
    maxWidth: parseInt(app.dataset.maxWidth || 240, 10),
    minLength: parseInt(app.dataset.minLength || 20, 10),
    maxLength: parseInt(app.dataset.maxLength || 300, 10),
    wBase: parseInt(app.dataset.wBase || app.dataset.minWidth || 12, 10),
    lBase: parseInt(app.dataset.lBase || app.dataset.minLength || 20, 10),
    liningIndex: 1,
    lining1Rate: parseFloat(app.dataset.lining1Rate || 0),
    lining2Rate: parseFloat(app.dataset.lining2Rate || 0),
    lining3Rate: parseFloat(app.dataset.lining3Rate || 0),
    lining4Rate: parseFloat(app.dataset.lining4Rate || 0),
    lining5Rate: parseFloat(app.dataset.lining5Rate || 0),
    lining6Rate: parseFloat(app.dataset.lining6Rate || 0)
  };

  const mediaConfigRoot = document.getElementById('product-media-config');
  const mainImageContainer = document.getElementById('main-image-container');
  const mainImageEl = document.getElementById('main-product-image');
  const thumbnailGrid = document.getElementById('product-thumbnail-grid');

  const parseProductMediaConfig = () => {
    const config = {
      variants: new Map(),
      shared: [],
    };

    if (!mediaConfigRoot) return config;

    mediaConfigRoot.querySelectorAll('[data-variant-media]').forEach((node) => {
      const variantId = node.dataset.variantId;
      if (!variantId) return;
      config.variants.set(String(variantId), {
        id: node.dataset.mediaId || '',
        src: node.dataset.url || '',
        thumbSrc: node.dataset.thumbUrl || node.dataset.url || '',
        alt: node.dataset.alt || '',
      });
    });

    mediaConfigRoot.querySelectorAll('[data-shared-media]').forEach((node) => {
      config.shared.push({
        id: node.dataset.mediaId || '',
        src: node.dataset.url || '',
        thumbSrc: node.dataset.thumbUrl || node.dataset.url || '',
        alt: node.dataset.alt || '',
      });
    });

    return config;
  };

  const productMediaConfig = parseProductMediaConfig();

  const syncLightboxMedia = (gallery) => {
    window.__LUMI_PDP_MEDIA = gallery.map((media) => ({
      src: media.src,
      alt: media.alt || '',
    }));
  };

  const buildGalleryMedia = (variantId) => {
    const selectedMedia = productMediaConfig.variants.get(String(variantId));
    const fallbackMedia =
      selectedMedia ||
      (mainImageEl
        ? {
            id: mainImageContainer?.dataset.mediaId || 'fallback',
            src: mainImageEl.src,
            thumbSrc: mainImageEl.src,
            alt: mainImageEl.alt || '',
          }
        : null);

    if (!fallbackMedia) return [];

    const sharedMedia = productMediaConfig.shared.filter((media) => media.id !== fallbackMedia.id);
    return [fallbackMedia, ...sharedMedia];
  };

  const renderVariantMedia = (variantId) => {
    if (!mainImageEl || !mainImageContainer) return;

    const gallery = buildGalleryMedia(variantId);
    if (!gallery.length) return;

    const [mainMedia, ...sharedMedia] = gallery;

    if (mainImageContainer) {
      mainImageContainer.dataset.mediaIndex = '0';
      mainImageContainer.dataset.mediaId = mainMedia.id || '';
    }

    if (mainImageEl.src !== mainMedia.src) {
      const onLoad = () => {
        mainImageEl.classList.remove('opacity-0');
        mainImageEl.removeEventListener('load', onLoad);
      };
      mainImageEl.addEventListener('load', onLoad);
      mainImageEl.classList.add('opacity-0');
      mainImageEl.src = mainMedia.src;
    }

    mainImageEl.alt = mainMedia.alt || '';

    if (thumbnailGrid) {
      const visibleSharedMedia = sharedMedia.slice(0, 6);
      thumbnailGrid.innerHTML = visibleSharedMedia
        .map(
          (media, index) => `
            <div class="w-full relative pt-[100%] bg-gray-50 cursor-zoom-in" data-media-index="${index + 1}" data-media-id="${media.id || ''}">
              <img src="${media.thumbSrc}" alt="${(media.alt || '').replace(/"/g, '&quot;')}" class="absolute inset-0 w-full h-full object-cover object-center" loading="lazy" decoding="async">
            </div>
          `
        )
        .join('');
      thumbnailGrid.classList.toggle('hidden', visibleSharedMedia.length === 0);
    }

    syncLightboxMedia(gallery);
  };

  // Cache DOM elements
  const summaryHeader = document.getElementById('summary-header');
  const summaryLining = document.getElementById('summary-lining');
  const summaryTrim = document.getElementById('summary-trim');
  const summaryTieback = document.getElementById('summary-tieback');

  const inputWidth = document.querySelector('#calc-width');
  const inputLength = document.querySelector('#calc-length');
  const inputQty = document.getElementById('calc-qty');
  const btnQtyMinus = document.getElementById('calc-qty-minus');
  const btnQtyPlus = document.getElementById('calc-qty-plus');
  const elTotalPrice = document.querySelector('#calc-total-price');
  const inputHiddenPrice = document.querySelector('#calc-hidden-price');
  
  const widthContainer = document.getElementById('width-input-container');
  const widthError = document.getElementById('width-error');
  const lengthContainer = document.getElementById('length-input-container');
  const lengthError = document.getElementById('length-error');

  const btnAddToCart = document.getElementById('calc-add-to-cart');

  renderVariantMedia(state.variantId);

  // Helper: Format Currency
  const formatMoney = (amount) => {
    return '$' + amount.toFixed(2);
  };

  // Update UI Visuals and Price
  const updateUI = () => {
    // 1. Update Option Styles
    document.querySelectorAll('.calc-option').forEach(el => {
      const type = el.dataset.type;
      const val = el.dataset.value;
      const isSelected = state[type] === val;

      if (type === 'color') {
        if (isSelected) {
          el.classList.add('!border-black');
          el.classList.remove('border-gray-200');
        } else {
          el.classList.remove('!border-black');
          el.classList.add('border-gray-200');
        }
      } else if (['header', 'lining', 'trim', 'tieback', 'memory'].includes(type)) {
        if (isSelected) {
          el.classList.add('!border-[#2D4B3E]');
          el.classList.remove('border-gray-100', 'hover:border-gray-400');
        } else {
          el.classList.remove('!border-[#2D4B3E]');
          el.classList.add('border-gray-100', 'hover:border-gray-400');
        }
      }
    });

    // 2. Update Summaries
    if (summaryHeader) summaryHeader.textContent = state.header || '-';
    
    // Update summary-desc elements
    const updateSummaryDesc = (typeClass, stateVal, summaryDescId) => {
      let activeEl = null;
      document.querySelectorAll(`.${typeClass}`).forEach(el => {
        if (el.dataset.value === stateVal) activeEl = el;
      });
      const summaryDescEl = document.getElementById(summaryDescId);
      if (summaryDescEl) {
        summaryDescEl.textContent = activeEl ? (activeEl.dataset.desc || activeEl.dataset.label || stateVal) : (stateVal || '-');
      }
    };
    updateSummaryDesc('color-option', state.color, 'summary-desc-color');
    updateSummaryDesc('header-option', state.header, 'summary-desc-header');
    updateSummaryDesc('lining-option', state.lining, 'summary-desc-lining');
    updateSummaryDesc('tieback-option', state.tieback, 'summary-desc-tieback');
    updateSummaryDesc('memory-option', state.memory, 'summary-desc-memory');
    updateSummaryDesc('trim-option', state.trim, 'summary-desc-trim');

    // Helper to toggle summary rows based on block presence and selection
    const toggleRow = (rowId, isBlockPresent, hasValue) => {
      const row = document.getElementById(rowId);
      if (row) {
        // Only show if the block actually exists on the page AND the user has made a selection
        if (isBlockPresent && hasValue) {
          row.classList.remove('hidden');
          row.style.display = 'flex';
        } else {
          row.classList.add('hidden');
          row.style.display = 'none';
        }
      }
    };

    const hasColorBlock = document.querySelector('.color-option') !== null;
    const summaryDisplayColor = document.getElementById('summary-display-color');
    if (summaryDisplayColor) summaryDisplayColor.textContent = state.color || '-';
    toggleRow('summary-row-color', hasColorBlock, !!state.color);
    
    const hasHeaderBlock = document.querySelector('.header-option') !== null;
    const summaryDisplayHeader = document.getElementById('summary-display-header');
    if (summaryDisplayHeader) summaryDisplayHeader.textContent = state.header || '-';
    toggleRow('summary-row-header', hasHeaderBlock, !!state.header);

    const hasSizeBlock = document.querySelector('#calc-width') !== null || document.querySelector('#calc-length') !== null;
    const summarySize = document.getElementById('summary-size');
    const summaryDisplaySize = document.getElementById('summary-display-size');
    const hasSizeValue = state.width > 0 && state.length > 0;
    if (hasSizeValue) {
      const sizeText = `${state.width}"W x ${state.length}"L`;
      if (summarySize) summarySize.textContent = sizeText;
      if (summaryDisplaySize) summaryDisplaySize.textContent = sizeText + ' (per panel)';
    } else {
      if (summarySize) summarySize.textContent = '';
      if (summaryDisplaySize) summaryDisplaySize.textContent = '-';
    }
    toggleRow('summary-row-size', hasSizeBlock, hasSizeValue);
    
    const hasLiningBlock = document.querySelector('.lining-option') !== null;
    if (summaryLining) summaryLining.textContent = state.lining || '-';
    const summaryDisplayLining = document.getElementById('summary-display-lining');
    if (summaryDisplayLining) summaryDisplayLining.textContent = state.lining || '-';
    toggleRow('summary-row-lining', hasLiningBlock, !!state.lining);

    const hasTrimBlock = document.querySelector('.trim-option') !== null;
    if (summaryTrim) summaryTrim.textContent = state.trim || '-';
    const summaryDisplayTrim = document.getElementById('summary-display-trim');
    if (summaryDisplayTrim) summaryDisplayTrim.textContent = state.trim || '-';
    toggleRow('summary-row-trim', hasTrimBlock, !!state.trim);

    const hasTiebackBlock = document.querySelector('.tieback-option') !== null;
    if (summaryTieback) summaryTieback.textContent = state.tieback || '-';
    const summaryDisplayTieback = document.getElementById('summary-display-tieback');
    if (summaryDisplayTieback) summaryDisplayTieback.textContent = state.tieback || '-';
    toggleRow('summary-row-tieback', hasTiebackBlock, !!state.tieback);

    const hasMemoryBlock = document.querySelector('.memory-option') !== null;
    const summaryMemory = document.getElementById('summary-memory');
    if (summaryMemory) summaryMemory.textContent = state.memory || '-';
    const summaryDisplayMemory = document.getElementById('summary-display-memory');
    if (summaryDisplayMemory) summaryDisplayMemory.textContent = state.memory || '-';
    toggleRow('summary-row-memory', hasMemoryBlock, !!state.memory);

    const roomLabelInput = document.getElementById('calc-room-label');
    const summaryDisplayRoomRow = document.getElementById('summary-row-room');
    const summaryDisplayRoom = document.getElementById('summary-display-room');
    if (roomLabelInput && roomLabelInput.value.trim() !== '') {
      if (summaryDisplayRoomRow) summaryDisplayRoomRow.classList.remove('hidden');
      if (summaryDisplayRoom) summaryDisplayRoom.textContent = roomLabelInput.value.trim();
    } else {
      if (summaryDisplayRoomRow) summaryDisplayRoomRow.classList.add('hidden');
      if (summaryDisplayRoom) summaryDisplayRoom.textContent = '';
    }

    const summaryDisplayQty = document.getElementById('summary-display-qty');
    if (summaryDisplayQty) summaryDisplayQty.textContent = `${state.quantity} panel${state.quantity > 1 ? 's' : ''}`;
    
    const summaryDisplayQtyBottom = document.getElementById('summary-display-qty-bottom');
    if (summaryDisplayQtyBottom) summaryDisplayQtyBottom.textContent = `${state.quantity} panel${state.quantity > 1 ? 's' : ''}`;

    // 3. Update Quantity
    if (inputQty) inputQty.value = state.quantity;

    // 4. Calculate Price
    // New Tiered Pricing Algorithm based on Width and Length
    let wExtra = 0;
    let lExtra = 0;
    const w = state.width || 0;
    const l = state.length || 0;

    if (w > 0 && l > 0) {
      if (state.wRate1 > 0 || state.lRate1 > 0) {
        const wBase = Math.max(0, w - state.wBase);
        if (w <= 100) {
          wExtra = wBase * state.wRate1;
        } else if (w <= 150) {
          wExtra = ((100 - state.wBase) * state.wRate1) + (w - 100) * state.wRate2;
        } else {
          wExtra = ((100 - state.wBase) * state.wRate1) + (50 * state.wRate2) + (w - 150) * state.wRate3;
        }

        const lBase = Math.max(0, l - state.lBase);
        if (l <= 102) {
          lExtra = lBase * state.lRate1;
        } else {
          lExtra = ((102 - state.lBase) * state.lRate1) + (l - 102) * state.lRate2;
        }
      } else {
        wExtra = (Math.max(0, w - state.wBase) * state.widthMultiplier) + (Math.max(0, l - state.lBase) * state.lengthMultiplier);
      }
    }

    // Update lining card prices dynamically on the UI
    document.querySelectorAll('.lining-option').forEach(el => {
      const rate = parseFloat(el.dataset.liningRate || 0);
      const priceDisplay = el.querySelector('.lining-dynamic-price');
      
      let cost = 0;
      if (rate > 0 && w > 0 && l > 0) {
        cost = (Math.max(0, w - state.minWidth) + Math.max(0, l - state.minLength)) * rate;
      }
      
      if (priceDisplay) {
        priceDisplay.textContent = '+' + formatMoney(cost);
      }
      // Store the dynamically calculated surcharge back into the DOM element for Add To Cart logic if needed
      el.dataset.surcharge = cost;
      
      // If this is the currently selected lining, update the global liningSurcharge state
      if (state.lining === el.dataset.value) {
        state.liningSurcharge = cost;
      }
    });

    // Addons: Lining, Trim, Tieback, Memory
    let memoryPrice = 0;
    if (state.memory) {
      document.querySelectorAll('.memory-option').forEach(el => {
        if (el.dataset.value === state.memory) {
          memoryPrice = parseFloat(el.dataset.price || 0);
        }
      });
    }

    const unitPrice = state.basePrice + wExtra + lExtra + state.liningSurcharge + state.trimPrice + state.tiebackPrice + memoryPrice;

    // Ensure total is at least base price * quantity
    let totalPrice = unitPrice * state.quantity;
    const minAllowedPrice = state.basePrice * state.quantity;
    
    if (isNaN(totalPrice) || totalPrice < minAllowedPrice) {
      totalPrice = minAllowedPrice;
    }

    if (elTotalPrice) {
      elTotalPrice.innerText = formatMoney(totalPrice);
    }
    document.querySelectorAll('.top-calc-price').forEach(el => {
      el.innerText = formatMoney(totalPrice);
    });
    if (inputHiddenPrice) {
      inputHiddenPrice.value = formatMoney(totalPrice);
    }

    // Force browser reflow to ensure price display updates immediately
    void document.getElementById('curtain-calculator-app')?.offsetHeight;

    // Sync hidden inputs for Shopify properties
    const hiddenColor = document.getElementById('calc-hidden-color');
    if (hiddenColor) hiddenColor.value = state.color;
    
    const hiddenHeader = document.getElementById('calc-hidden-header');
    if (hiddenHeader) hiddenHeader.value = state.header;
    
    const hiddenLining = document.getElementById('calc-hidden-lining');
    if (hiddenLining) hiddenLining.value = state.lining;
    
    const hiddenTrim = document.getElementById('calc-hidden-trim');
    if (hiddenTrim) hiddenTrim.value = state.trim;
    
    const hiddenTieback = document.getElementById('calc-hidden-tieback');
    if (hiddenTieback) hiddenTieback.value = state.tieback;
    
    const hiddenMemory = document.getElementById('calc-hidden-memory');
    if (hiddenMemory) hiddenMemory.value = state.memory;
  };

  // Bind Option Clicks
  document.querySelectorAll('.calc-option').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault(); 
      const type = el.dataset.type;
      const val = el.dataset.value;
      
      // Enforce addon pricing as requested: Trim +$10, Tieback +$5
      let surcharge = parseFloat(el.dataset.surcharge || 0);
      let price = parseFloat(el.dataset.price || 0);
      state[type] = val;
      if (type === 'lining') {
        state.liningSurcharge = surcharge;
        state.liningIndex = parseInt(el.dataset.index || 1, 10);
      }
      if (type === 'trim') state.trimPrice = price;
      if (type === 'tieback') state.tiebackPrice = price;
      // memoryPrice is calculated directly in updateUI() based on state.memory

      // Clear inline error if it exists for this section
      const section = el.closest('.calculator-section');
      if (section) {
        const errorMsg = section.querySelector('.inline-error-msg');
        if (errorMsg) {
          errorMsg.remove();
        }
      }

      // Color Image Sync Logic (Alt Text Matching)
      if (type === 'color') {
        const variantId = el.dataset.variantId;
        const colorName = el.dataset.colorName;

        if (variantId) state.variantId = variantId;

        const selectedColorNameEl = document.getElementById('selected-color-name');
        if (selectedColorNameEl) selectedColorNameEl.textContent = colorName || val;

        const variantIdInput = document.getElementById('variant-id-input');
        if (variantIdInput && variantId) variantIdInput.value = variantId;
        if (variantId) renderVariantMedia(variantId);

        // --- Dynamic Specification Table Update ---
        const specMaterial = el.dataset.material;
        const specGsm = el.dataset.gsm;
        const specShading = el.dataset.shading;

        const elMaterial = document.getElementById('spec-material');
        const rowMaterial = document.getElementById('row-spec-material');
        if (elMaterial && rowMaterial) {
          if (specMaterial) {
            elMaterial.textContent = specMaterial;
            rowMaterial.classList.remove('hidden');
          } else {
            rowMaterial.classList.add('hidden');
          }
        }

        const elGsm = document.getElementById('spec-gsm');
        const rowGsm = document.getElementById('row-spec-gsm');
        if (elGsm && rowGsm) {
          if (specGsm) {
            elGsm.textContent = specGsm;
            rowGsm.classList.remove('hidden');
          } else {
            rowGsm.classList.add('hidden');
          }
        }

        const elShading = document.getElementById('spec-shading');
        const rowShading = document.getElementById('row-spec-shading');
        if (elShading && rowShading) {
          if (specShading) {
            elShading.textContent = specShading;
            rowShading.classList.remove('hidden');
          } else {
            rowShading.classList.add('hidden');
          }
        }
      }

      updateUI();
    });
  });

  // Bind Size Inputs with Validation
  const validateSize = (type, val, min, max, container, errorEl) => {
    if (!val || val < min || val > max) {
      container.classList.add('border-red-500', 'ring-1', 'ring-red-500');
      container.classList.remove('border-gray-200', 'focus-within:border-gray-400');
      errorEl.textContent = `${type.toLowerCase()} must be between ${min} and ${max}.`;
      errorEl.classList.remove('hidden');
      errorEl.classList.add('block');
      return false;
    } else {
      container.classList.remove('border-red-500', 'ring-1', 'ring-red-500');
      container.classList.add('border-gray-200', 'focus-within:border-gray-400');
      errorEl.classList.add('hidden');
      errorEl.classList.remove('block');
      return true;
    }
  };

  if (inputWidth) {
    inputWidth.addEventListener('input', (e) => {
      let val = parseFloat(e.target.value);
      if (isNaN(val)) val = 0;
      validateSize('Width', val, state.minWidth, state.maxWidth, widthContainer, widthError);
      
      state.width = val;
      updateUI();
    });
  }
  
  if (inputLength) {
    inputLength.addEventListener('input', (e) => {
      let val = parseFloat(e.target.value);
      if (isNaN(val)) val = 0;
      
      validateSize('Length', val, state.minLength, state.maxLength, lengthContainer, lengthError);
      
      state.length = val;
      updateUI();
    });
  }

  // Bind Quantity
  if (btnQtyMinus) {
    btnQtyMinus.addEventListener('click', () => {
      if (state.quantity > 1) {
        state.quantity--;
        updateUI();
      }
    });
  }
  if (btnQtyPlus) {
    btnQtyPlus.addEventListener('click', () => {
      state.quantity++;
      updateUI();
    });
  }

  const roomLabelInput = document.getElementById('calc-room-label');
  if (roomLabelInput) {
    roomLabelInput.addEventListener('input', () => {
      updateUI();
    });
  }

    // Add To Cart Logic
  if (btnAddToCart) {
    btnAddToCart.addEventListener('click', async (e) => {
      e.preventDefault();
      
      // Clear any previous inline error messages
      document.querySelectorAll('.inline-error-msg').forEach(el => el.remove());

      // Helper function to show inline error and scroll
      const showInlineError = (containerSelector, message, shouldScroll) => {
        const container = document.querySelector(containerSelector);
        if (container) {
          const section = container.closest('.calculator-section');
          if (section) {
            const errorDiv = document.createElement('div');
            errorDiv.className = 'inline-error-msg text-red-600 text-[13px] mb-3 font-medium animate-pulse';
            errorDiv.textContent = message;
            
            // Find the title row (which usually contains the step number and title)
            // Typically it's the first div with flex, justify-between, items-center inside the section
            const titleRow = section.querySelector('.flex.justify-between.items-center');
            
            if (titleRow && titleRow.nextElementSibling) {
              // Insert right after the title row
              titleRow.parentNode.insertBefore(errorDiv, titleRow.nextElementSibling);
            } else {
              // Fallback to prepend to the section if title row not found
              section.prepend(errorDiv);
            }
            
            // Scroll to the section smoothly only if it's the first error
            if (shouldScroll) {
              section.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
      };

      // Dynamically check required options only if they exist in the DOM
      const hasHeaderOptions = document.querySelector('.header-option') !== null;
      const hasLiningOptions = document.querySelector('.lining-option') !== null;
      const hasTrimOptions = document.querySelector('.trim-option') !== null;
      const hasTiebackOptions = document.querySelector('.tieback-option') !== null;
      const hasMemoryOptions = document.querySelector('.memory-option') !== null;

      let missingOptionFound = false;

      if (hasHeaderOptions && !state.header) {
        showInlineError('.header-option', 'Please select at least one option.', !missingOptionFound);
        missingOptionFound = true;
      } 
      if (hasLiningOptions && !state.lining) {
        showInlineError('.lining-option', 'Please select at least one option.', !missingOptionFound);
        missingOptionFound = true;
      } 
      if (hasTrimOptions && !state.trim) {
        showInlineError('.trim-option', 'Please select at least one option.', !missingOptionFound);
        missingOptionFound = true;
      } 
      if (hasTiebackOptions && !state.tieback) {
        showInlineError('.tieback-option', 'Please select at least one option.', !missingOptionFound);
        missingOptionFound = true;
      } 
      if (hasMemoryOptions && !state.memory) {
        showInlineError('.memory-option', 'Please select at least one option.', !missingOptionFound);
        missingOptionFound = true;
      }

      // Check validation for size
      let isValid = true;
      if (state.width > 0) {
        isValid = validateSize('Width', state.width, state.minWidth, state.maxWidth, widthContainer, widthError) && isValid;
      }
      if (state.length > 0) {
        isValid = validateSize('Length', state.length, state.minLength, state.maxLength, lengthContainer, lengthError) && isValid;
      }

      if (!state.width || !state.length || !isValid) {
        // Trigger visual validation errors on the inputs
        if (!state.width || !isValid) {
            validateSize('Width', state.width || 0, state.minWidth, state.maxWidth, widthContainer, widthError);
        }
        if (!state.length || !isValid) {
            validateSize('Length', state.length || 0, state.minLength, state.maxLength, lengthContainer, lengthError);
        }
        
        // Only scroll to size inputs if no previous options were missing
        if (!missingOptionFound) {
          if (inputWidth && (!state.width || !isValid)) {
            inputWidth.scrollIntoView({ behavior: 'smooth', block: 'center' });
            inputWidth.focus();
          } else if (inputLength && (!state.length || !isValid)) {
            inputLength.scrollIntoView({ behavior: 'smooth', block: 'center' });
            inputLength.focus();
          }
        }
        missingOptionFound = true;
      }

      if (missingOptionFound) {
        return; // Stop execution if any option or size is missing
      }

      // Show spinner
      const btnText = btnAddToCart.querySelector('.btn-text');
      const btnSpinner = btnAddToCart.querySelector('.btn-spinner');
      if (btnText) btnText.textContent = 'Adding...';
      if (btnSpinner) btnSpinner.classList.remove('hidden');
      btnAddToCart.disabled = true;

      const roomLabel = document.getElementById('calc-room-label');

      // Read user-selected configuration properties from hidden form fields
      const getProp = (id) => {
        const el = document.getElementById(id);
        return el ? el.value : '';
      };

      // Calculate extra surcharge per panel (must match algorithm in updateUI)
      let wExtra = 0, lExtra = 0;
      const w = state.width || 0, l = state.length || 0;
      if (w > 0 && l > 0) {
        if (state.wRate1 > 0 || state.lRate1 > 0) {
          const wBase = Math.max(0, w - state.wBase);
          if (w <= 100) wExtra = wBase * state.wRate1;
          else if (w <= 150) wExtra = ((100 - state.wBase) * state.wRate1) + (w - 100) * state.wRate2;
          else wExtra = ((100 - state.wBase) * state.wRate1) + (50 * state.wRate2) + (w - 150) * state.wRate3;

          const lBase = Math.max(0, l - state.lBase);
          if (l <= 102) lExtra = lBase * state.lRate1;
          else lExtra = ((102 - state.lBase) * state.lRate1) + (l - 102) * state.lRate2;
        } else {
          wExtra = (Math.max(0, w - state.wBase) * state.widthMultiplier) + (Math.max(0, l - state.lBase) * state.lengthMultiplier);
        }
      }
      let memoryPrice = 0;
      if (state.memory) {
        document.querySelectorAll('.memory-option').forEach(el => {
          if (el.dataset.value === state.memory) memoryPrice = parseFloat(el.dataset.price || 0);
        });
      }

      // Calculate exact custom extra cost (per panel)
      const customExtraPerPanel = wExtra + lExtra + state.liningSurcharge + state.trimPrice + state.tiebackPrice + memoryPrice;

      // ── Server-side price validation before add-to-cart ──────────────────────
      const clientTotalPrice = (state.basePrice + customExtraPerPanel) * state.quantity;

      const validationRes = await fetch('/apps/curtain/api/price-validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId: app.dataset.productId,
          clientUnitPrice: Math.round((state.basePrice + customExtraPerPanel) * 100) / 100,
          clientTotalPrice: Math.round(clientTotalPrice * 100) / 100,
          width: state.width,
          length: state.length,
          liningIndex: state.liningIndex || 0,
          trimPrice: state.trimPrice || 0,
          tiebackPrice: state.tiebackPrice || 0,
          quantity: state.quantity,
        })
      }).catch(() => null);

      let serverPriceOverride = null;
      if (validationRes && validationRes.ok) {
        const vData = await validationRes.json();
        if (vData.mismatch) {
          // Use server price, warn admin
          console.error('[PRICE GUARD] Server price mismatch — using server price', vData);
          alert(`⚠️ Price correction applied by server.\nClient price: $${vData.clientTotalPrice}\nServer price: $${vData.serverTotalPrice}\n\nCorrected price will be used.`);
          serverPriceOverride = vData.serverTotalPrice;
        }
      }

      // ── Build formData with validated price ──────────────────────────────────
      const finalUnitPrice = serverPriceOverride
        ? serverPriceOverride / state.quantity
        : state.basePrice + customExtraPerPanel;

      const properties = {
        'Color': getProp('calc-hidden-color'),
        'Header Style': getProp('calc-hidden-header'),
        'Size': (state.width && state.length)
          ? `${state.width}"W x ${state.length}"L (per panel)`
          : '',
        'Lining': getProp('calc-hidden-lining'),
        'Side Hem Trim': getProp('calc-hidden-trim'),
        'Tieback': getProp('calc-hidden-tieback'),
        'Body Memory Shaped': getProp('calc-hidden-memory'),
        // Hidden property: Price used for frontend total calculation, passed to Draft Order API
        'Price': formatMoney(finalUnitPrice),
      };

      // Filter out empty values
      Object.keys(properties).forEach(k => {
        if (!properties[k]) delete properties[k];
      });

      // Build formData - only add main curtain item
      const formData = {
        items: [{
          id: state.variantId,
          quantity: state.quantity,
          properties: properties
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.description || errData.message || 'Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Success: update cart bubble count
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(res => res.json())
          .then(cartData => {
            // Include in visible cart count
            const visibleCount = (cartData.items || []).reduce((sum, item) => {
              return sum + (item.quantity || 0);
            }, 0);

            const countBubble = document.querySelector('.custom-cart-count-bubble');
            const countSpan = document.querySelector('.cart-count-number');
            if (countSpan) countSpan.textContent = visibleCount;
            if (countBubble) {
              if (visibleCount > 0) countBubble.classList.remove('hidden');
              else countBubble.classList.add('hidden');
            }
          })
          .catch(err => console.error('Error updating cart bubble:', err));

        // After adding: redirect to confirmation page (without opening cart drawer)
        window.location.href = '/pages/cart-confirmation';
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        alert('There was an error adding the item to the cart: ' + error.message);
      })
      .finally(() => {
        if (btnText) btnText.textContent = 'Add to Cart';
        if (btnSpinner) btnSpinner.classList.add('hidden');
        btnAddToCart.disabled = false;
      });
    });
  }

  // Initial Render
  updateUI();

  }

  // --- 3. Info Drawer Logic ---
  const drawer = document.getElementById('info-drawer');
  const drawerOverlay = document.getElementById('info-drawer-overlay');
  const drawerClose = document.getElementById('info-drawer-close');
  const drawerTitle = document.getElementById('info-drawer-title');
  const drawerContent = document.getElementById('info-drawer-content');

  const openDrawer = (title, contentHtml) => {
    if (drawerTitle) drawerTitle.textContent = title;
    if (drawerContent) drawerContent.innerHTML = contentHtml;
    
    if (drawerOverlay) {
      drawerOverlay.classList.remove('hidden');
      setTimeout(() => drawerOverlay.classList.remove('opacity-0', 'pointer-events-none'), 10);
    }
    if (drawer) {
      drawer.classList.remove('translate-x-full');
    }
  };

  const closeDrawer = () => {
    if (drawerOverlay) {
      drawerOverlay.classList.add('opacity-0', 'pointer-events-none');
      setTimeout(() => drawerOverlay.classList.add('hidden'), 300);
    }
    if (drawer) {
      drawer.classList.add('translate-x-full');
    }
  };

  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  document.querySelectorAll('.drawer-trigger').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const title = btn.dataset.drawerTitle || 'Guidelines';
      const contentId = btn.dataset.drawerContentId;
      const contentEl = document.getElementById(contentId);
      let contentHtml = contentEl ? contentEl.innerHTML : '<p>No details provided.</p>';
      
      // Inject dynamic accordion items if they match the title
      const cssSelectorTitle = title.replace(/"/g, '\\"');
      const accordionItems = document.querySelectorAll(`.drawer-accordion-item[data-target="${cssSelectorTitle}"]`);
      if (accordionItems.length > 0) {
        let accordionHtml = '';
        accordionItems.forEach(item => {
          accordionHtml += item.innerHTML;
        });
        // Append accordion items to the existing content
        // If the original content is just whitespace, don't add the top margin
        if (contentHtml.trim() === '') {
          contentHtml = accordionHtml;
        } else {
          contentHtml += `<div class="mt-2">${accordionHtml}</div>`;
        }
      }

      openDrawer(title, contentHtml);
    });
  });
  // --- 4. Swatch Drawer Logic ---
  // We use event delegation here because the trigger button might be dynamically rendered
  // or the script might run before the button is fully parsed in the DOM.
  const swatchDrawer = document.getElementById('swatch-drawer');
  const swatchOverlay = document.getElementById('swatch-drawer-overlay');
  const swatchClose = document.getElementById('swatch-drawer-close');
  const btnAddSwatches = document.getElementById('btn-add-swatches');
  const swatchItems = document.querySelectorAll('.swatch-item');
  let selectedSwatches = [];

  const openSwatchDrawer = () => {
    if (swatchOverlay) {
      swatchOverlay.classList.remove('hidden');
      setTimeout(() => swatchOverlay.classList.remove('opacity-0', 'pointer-events-none'), 10);
    }
    if (swatchDrawer) {
      swatchDrawer.classList.remove('translate-x-full');
    }
  };

  const closeSwatchDrawer = () => {
    if (swatchOverlay) {
      swatchOverlay.classList.add('opacity-0', 'pointer-events-none');
      setTimeout(() => swatchOverlay.classList.add('hidden'), 300);
    }
    if (swatchDrawer) {
      swatchDrawer.classList.add('translate-x-full');
    }
  };

  if (swatchClose) swatchClose.addEventListener('click', closeSwatchDrawer);
  if (swatchOverlay) swatchOverlay.addEventListener('click', closeSwatchDrawer);

  // Use event delegation for the trigger button to ensure it works even if DOM is not fully ready
  document.addEventListener('click', (e) => {
    const triggerBtn = e.target.closest('.swatch-drawer-trigger');
    if (triggerBtn) {
      e.preventDefault();
      openSwatchDrawer();
    }
  });

  // Handle swatch selection
  swatchItems.forEach(item => {
    item.addEventListener('click', () => {
      const variantId = item.dataset.variantId;
      const icon = item.querySelector('.swatch-selected-icon');
      
      const index = selectedSwatches.indexOf(variantId);
      if (index > -1) {
        // Deselect
        selectedSwatches.splice(index, 1);
        item.classList.remove('!border-[#2D4B3E]', 'ring-1', 'ring-[#2D4B3E]');
        if (icon) {
          icon.classList.remove('opacity-100', 'scale-100');
          icon.classList.add('opacity-0', 'scale-50');
        }
      } else {
        // Select
        selectedSwatches.push(variantId);
        item.classList.add('!border-[#2D4B3E]', 'ring-1', 'ring-[#2D4B3E]');
        if (icon) {
          icon.classList.remove('opacity-0', 'scale-50');
          icon.classList.add('opacity-100', 'scale-100');
        }
      }

      // Update button state
      if (btnAddSwatches) {
        const btnText = btnAddSwatches.querySelector('.btn-text');
        if (selectedSwatches.length > 0) {
          btnAddSwatches.disabled = false;
          if (btnText) btnText.textContent = `ADD TO CART - ${selectedSwatches.length} Selected`;
        } else {
          btnAddSwatches.disabled = true;
          if (btnText) btnText.textContent = `ADD TO CART - 0 Selected`;
        }
      }
    });
  });

  // Add swatches to cart
  if (btnAddSwatches) {
    btnAddSwatches.addEventListener('click', () => {
      if (selectedSwatches.length === 0) return;

      const btnText = btnAddSwatches.querySelector('.btn-text');
      const btnSpinner = btnAddSwatches.querySelector('.btn-spinner');
      
      if (btnText) btnText.textContent = 'Adding...';
      if (btnSpinner) btnSpinner.classList.remove('hidden');
      btnAddSwatches.disabled = true;

      const items = selectedSwatches.map(id => ({
        id: id,
        quantity: 1
      }));

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(async response => {
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.description || errData.message || 'Failed to add swatches to cart');
        }
        return response.json();
      })
      .then(() => {
        // Clear selection after successful add
        selectedSwatches = [];
        swatchItems.forEach(item => {
          item.classList.remove('!border-[#2D4B3E]', 'ring-1', 'ring-[#2D4B3E]');
          const icon = item.querySelector('.swatch-selected-icon');
          if (icon) {
            icon.classList.remove('opacity-100', 'scale-100');
            icon.classList.add('opacity-0', 'scale-50');
          }
        });
        
        if (btnText) btnText.textContent = `ADD TO CART - 0 Selected`;
        
        // Close drawer
        closeSwatchDrawer();

        // Update cart UI
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(res => res.json())
          .then(cartData => {
            // Include all items in visible cart count
            const visibleCount = (cartData.items || []).reduce((sum, item) => {
              if (item.sku === 'SEL-CT-001') return sum + 1;
              return sum + (item.quantity || 0);
            }, 0);

            const countBubble = document.querySelector('.custom-cart-count-bubble');
            const countSpan = document.querySelector('.cart-count-number');
            if (countSpan) countSpan.textContent = visibleCount;
            if (countBubble) {
              if (visibleCount > 0) countBubble.classList.remove('hidden');
              else countBubble.classList.add('hidden');
            }
          });

      })
      .catch(error => {
        console.error('Error adding swatches:', error);
        alert('There was an error adding swatches to the cart: ' + error.message);
      })
      .finally(() => {
        if (btnSpinner) btnSpinner.classList.add('hidden');
        if (selectedSwatches.length > 0) {
          btnAddSwatches.disabled = false;
          if (btnText) btnText.textContent = `ADD TO CART - ${selectedSwatches.length} Selected`;
        }
      });
    });
  }
  };

  // Execute immediately without waiting for DOMContentLoaded,
  // since the script is included at the bottom of the HTML section.
  initCalculator();
})();
